import React, { useRef } from 'react';
import PhotoEtudiant from './PhotoEtudiant';
import { teinteAvatar, initiales } from '../services/etudiantsAffichage';

/**
 * LES PHOTOS DES ENSEIGNANTS — l'affichage et le choix (2026-10-10, v74)
 * =====================================================================
 * · `AvatarEnseignant` : le visage (photo chargée AVEC le jeton, par `PhotoEtudiant` — un `<img src="/api/…">`
 *   nu partirait sans authentification et resterait gris), sinon les INITIALES, comme aujourd'hui.
 * · `ChoixPhotoEnseignant` : l'avatar de la maquette Enseignants (`.profile-avatar` + pastille appareil photo
 *   « Changer la photo »), utilisé dans la fiche (gestion) et dans « Mon espace » (l'enseignant lui-même).
 * La photo suit la PERSONNE d'une année sur l'autre (nom + prénom) : la déposer ici vaut pour toutes les années.
 */
export function AvatarEnseignant({ e, className = '', style, title, teinte = true }) {
    if (!e) return null;
    const secours = (
        <div className={className} style={{ ...(teinte ? { background: teinteAvatar(e.nom, e.prenom), color: '#fff' } : {}), ...style }} title={title}>
            {/* Maquette Enseignants : PRÉNOM puis NOM (« SL » pour Sophie LEROY) — l’inverse des étudiants. */}
            {initiales(e.prenom, e.nom)}
        </div>
    );
    return <PhotoEtudiant chemin={e.photo_url} className={`${className} av-photo`} alt="" title={title} secours={secours} />;
}

export function ChoixPhotoEnseignant({ e, modifiable, enCours, erreur, onDeposer, onRetirer, aide }) {
    const champ = useRef(null);
    return (
        <div className="ens-photo-choix">
            <div className="ens-photo-cadre">
                <AvatarEnseignant e={e} className="ens-photo-av" teinte={false} />
                {modifiable && (
                    <button type="button" className="ens-photo-cam" title="Changer la photo (.jpg ou .png, 2 Mo au plus)" aria-label="Changer la photo"
                            disabled={enCours} onClick={() => champ.current?.click()}>
                        <i className={'fa-solid ' + (enCours ? 'fa-circle-notch fa-spin' : 'fa-camera')} />
                    </button>
                )}
                <input ref={champ} type="file" accept="image/jpeg,image/png" style={{ display: 'none' }} aria-label="Fichier de la photo"
                       onChange={(ev) => { const f = ev.target.files?.[0]; ev.target.value = ''; if (f) onDeposer(f); }} />
            </div>
            <div className="ens-photo-texte">
                <div className="ens-photo-titre">{e.photo_url ? 'Photo' : 'Pas encore de photo'}</div>
                <div className="ens-photo-aide">{aide || "Elle suit l'enseignant d'une année sur l'autre. .jpg ou .png, 2 Mo au plus (réduite à 400 px)."}</div>
                {modifiable && e.photo_url && (
                    <button type="button" className="ens-photo-retirer" disabled={enCours} onClick={onRetirer}>
                        <i className="fa-solid fa-trash-can" /> Retirer la photo
                    </button>
                )}
                {erreur && <div className="ens-photo-erreur"><i className="fa-solid fa-circle-exclamation" /> {erreur}</div>}
            </div>
        </div>
    );
}
